import React from "react";

const CardSelectable = ({ title, data, onClick }) => {
  const renderCustomerInfo = () => {
    if (data.customer_name) {
      return (
        <div className="d-flex align-items-center ">
          <i className="pi pi-check-circle me-2" style={{ fontSize: "2em" }}></i>
          <div className="ms-3">
            <h5 className="fw-normal m-0">{data.customer_name}</h5>
            <p className="m-0">{data.customer_doc}</p>
          </div>
        </div>
      );
    }
    return null;
  };

  const renderAddressInfo = () => {
    if (data.address) {
      return (
        <div className="d-flex align-items-center ">
          <i className="pi pi-check-circle me-2" style={{ fontSize: "2em" }}></i>
          <div className="ms-3">
            <h5 className="fw-normal m-0">{data.address}</h5>
            <p className="m-0">{data.cep}</p>
          </div>
        </div>
      );
    }
    return null;
  };

  return (
    <div
      className={`w-100 border rounded py-3 px-3 card-selectable d-flex align-items-center ${data ? "card-selectable-complete" : ""}`}
      onClick={onClick}
    >
      {!data ? (
        <h5 className="d-flex align-items-center fw-normal m-0">
          <i className="pi pi-plus-circle me-2" style={{ fontSize: "2em" }}></i>
          {title}
        </h5>
      ) : (
        <div className="d-flex flex-column">
          {renderCustomerInfo()}
          {renderAddressInfo()}
        </div>
      )}
    </div>
  );
};

export default CardSelectable;
